import { render, staticRenderFns } from "./LiveBannedUsers.vue?vue&type=template&id=2ad2094e&"
import script from "./LiveBannedUsers.vue?vue&type=script&lang=js&"
export * from "./LiveBannedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports